import { useState } from "react";
import { useTranslation } from "react-i18next";
import {
  Box,
  Typography,
  Tabs,
  Tab,
  Paper,
} from "@mui/material";
import TransactionDetails from "../TransactionDetails/TransactionDetails";
import Sell from "../RedeemSell/Sell";
import Redeem from "../RedeemSell/Redeem";
import OfflineTransaction from "../OfflineTransaction/OfflineTransaction";
import DiamondPointsOrder from "../RedeemSell/DiamondPointsOrder";
import DiamondPointsOrdersTable from "../CustomerDiamondPointOrders/DiamondPointsOrdersTable";
import UserPointsOrder from "../RedeemSell/UserPointOrder";
import ProductOrder from "../ProductOrder/productOrder";
import NewGifts from "../Gifts/NewGifts";
import AllSubscriptionList from "../SubscriptionPlan/AllSubscriptionList";
import AccessControl from "../../Comman/AccessControl";
import { controlAllFeatureOptions } from "../../../configs/constants";
import { canShowPermission } from "../Permissions/permissionObject";
import { useEffect } from "react";
import InfoButton from "../../Comman/InfoButton";

export default function TransactionsPage() {
  const { t } = useTranslation();
  const [tabIndex, setTabIndex] = useState(0);

  const handleTabChange = (event, newValue) => {
    setTabIndex(newValue);
  };

  const [permissions, setPermissions] = useState({});

  useEffect(() => {
    const storedPermissions = localStorage.getItem("userPermissions");
    if (storedPermissions) {
      try {
        setPermissions(JSON.parse(storedPermissions));
      } catch (e) {
        console.error("Invalid permissions JSON", e);
      }
    }
  }, []);


  const canViewTransaction = canShowPermission(permissions, "transactionHistory", "view");
  const canViewSell = canShowPermission(permissions, "sell", "view");
  const canViewRedeem = canShowPermission(permissions, "redeem", "view");
  const canViewOfflineTransaction = canShowPermission(permissions, "offlineTransaction", "view");
  const canViewDiamondPoints = canShowPermission(permissions, "diamondPointsOrder", "view");
  const canViewUserPoints = canShowPermission(permissions, "userPointsOrder", "view");
  const canViewProductOrder = canShowPermission(permissions, "ProductOrder", "view");
  const canViewGifts = canShowPermission(permissions, "newGifts", "view");
  const canViewAutoDebitSubscriptions = canShowPermission(permissions, "allSubscriptionList", "view");

  const tabs = [
    canViewTransaction && {
      label: t("tabs.transactions"),
      content: (
        <Box sx={{ mt: 0 }}>
          <TransactionDetails />
        </Box>
      ),
    },

    canViewSell && {
      label: t("tabs.sellOrders"),
      content: (
        <AccessControl feature={controlAllFeatureOptions.Sell}>
          <Box sx={{ mt: 0 }}>
            <Sell />
          </Box>
        </AccessControl>
      ),
    },

    canViewRedeem && {
      label: t("tabs.redeemOrders"),
      content: (
        <AccessControl feature={controlAllFeatureOptions.Redeem}>
          <Box sx={{ mt: 0 }}>
            <Redeem />
          </Box>
        </AccessControl>
      ),
    },

    canViewOfflineTransaction && {
      label: t("tabs.offlineOrders"),
      content: (
        <Box sx={{ mt: 0 }}>
          <OfflineTransaction />
        </Box>
      ),
    },

    canViewDiamondPoints && {
      label: t("tabs.diamondPoints"),
      content: (
        <AccessControl feature={controlAllFeatureOptions.Diamond_Points}>
          <Box sx={{ mt: 0 }}>
            <DiamondPointsOrder />
          </Box>
        </AccessControl>
      ),
    },

    canViewDiamondPoints && {
      label: t("tabs.customerDiamondPoints"),
      content: (
        <AccessControl feature={controlAllFeatureOptions.Diamond_Points}>
          <Box sx={{ mt: 0 }}>
            <DiamondPointsOrdersTable />
          </Box>
        </AccessControl>
      ),
    },

    canViewUserPoints && {
      label: t("tabs.referralPoints"),
      content: (
        <Box sx={{ mt: 0 }}>
          <UserPointsOrder />
        </Box>
      ),
    },

    canViewProductOrder && {
      label: t("tabs.productOrders"),
      content: (
        <Box sx={{ mt: 0 }}>
          <ProductOrder />
        </Box>
      ),
    },

    canViewGifts && {
      label: t("tabs.giftsTransactions"),
      content: (
        <Box sx={{ mt: 0 }}>
          <NewGifts />
        </Box>
      ),
    },

    canViewAutoDebitSubscriptions && {
      label: t("tabs.autoDebitSubscriptions"),
      content: (
        <Box sx={{ mt: 0 }}>
          <AllSubscriptionList />
        </Box>
      ),
    },
  ].filter(Boolean);






  return (
    <Box sx={{ width: "100%", height: "100vh", overflow: "auto" }}>
      <Box sx={{ position: "relative" }}>
        <Box
          sx={{
            width: "100%",
            mt: { xs: 10, md: 10 },
            background: "#fff",
            borderRadius: "16px",
            boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
          }}
        >
          <Paper
            sx={{ p: { xs: 2, sm: 4 }, mb: 2, borderRadius: "16px" }}
            elevation={1}
          >
            <Tabs
              value={tabIndex}
              onChange={handleTabChange}
              textColor="primary"
              indicatorColor="primary"
              variant="scrollable"
              scrollButtons="auto"
              sx={{
                mb: 0,
                backgroundColor: "#f5f5f5",
                borderRadius: "8px",
                padding: "4px",
                "& .MuiTab-root": {
                  fontWeight: 600,
                  fontSize: "16px",
                  textTransform: "none",
                  minWidth: "auto",
                  px: 2,
                  borderRadius: "6px",
                  margin: "0 4px",
                  minHeight: "48px",
                  "&.Mui-selected": {
                    backgroundColor: "#fff",
                    color: "#7A3FFF",
                    boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
                    borderBottom: "3px solid #7A3FFF",
                  },
                  "&:hover": {
                    backgroundColor: "rgba(122, 63, 255, 0.08)",
                  },
                },
                "& .MuiTabs-indicator": {
                  display: "none",
                },
              }}
            >
              {tabs.map((tab, index) => (
                <Tab key={index} label={tab.label} />
              ))}
            </Tabs>
            <Box sx={{ mt: 0 }}>
              {tabs[tabIndex]?.content}
            </Box>
          </Paper>
        </Box>
        <Box
    sx={{
      position: "fixed",
      bottom: 24,
      right: 24,
      zIndex: 1000,
    }}
  >
    <InfoButton pageName="TRANSACTION_AND_ORDER" />
  </Box>
      </Box>
   </Box>
  );
}

